// extracted by mini-css-extract-plugin
module.exports = {"universeAddBtn":"styles__universeAddBtn--BM7nl","deleteBtn":"styles__deleteBtn--1PYNk"};